import { Listbox } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import type { SelectOption } from "../../types/api";

export default function FormFilterSelect({
  label,
  value,
  options,
  onChange,
  disabled = false,
  compact = false,
}: {
  label: string;
  value: string;
  options: SelectOption<string | number>[];
  onChange: (value: string) => void;
  disabled?: boolean;
  compact?: boolean;
}) {
  const selected = options.find((option) => String(option.value) === value);
  return (
    <Listbox value={value} onChange={onChange} disabled={disabled}>
      <div className="relative min-w-0">
        <Listbox.Label
          className={compact ? "sr-only" : "mb-1 block text-sm font-medium text-gray-700"}
        >
          {label}
        </Listbox.Label>
        <Listbox.Button className="flex min-h-10 w-full items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-sm text-gray-700 hover:border-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 disabled:cursor-not-allowed disabled:opacity-50">
          <span className="truncate">{selected?.label || value || label}</span>
          <ChevronDownIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-gray-400" />
        </Listbox.Button>
        <Listbox.Options
          anchor={{ to: "bottom end", gap: 4, padding: 8 }}
          className="z-50 max-h-60 w-[var(--button-width)] min-w-[12rem] overflow-auto rounded-lg border border-gray-200 bg-white p-1 text-sm focus:outline-none"
        >
          {options.map((option) => (
            <Listbox.Option
              key={option.value}
              value={String(option.value)}
              className={({ active }) =>
                `flex cursor-pointer items-center justify-between gap-3 rounded-md px-3 py-2 ${active ? "bg-primary-50 text-primary-700" : "text-gray-700"}`
              }
            >
              {({ selected }) => (
                <>
                  <span className="min-w-0 break-words">{option.label}</span>
                  {selected && (
                    <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-primary-600" />
                  )}
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
